import Web3 from "web3";
import React from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  Input,
  Label,
  FormGroup,
  Form,
} from "reactstrap";
import { FiEdit } from "react-icons/fi";
import { create } from "ipfs-http-client";
import Page from "../../components/Page";
import Avatar from "../../components/Avatar";
import PageSpinner from "../../components/PageSpinner";
import NotificationSystem from "react-notification-system";
import { contractAddress } from "./Membership";
import userImage from "../../assets/img/user.jpg";
import * as GeneralFunctions from "../../GeneralFunctions";
import { NOTIFICATION_SYSTEM_STYLE } from "../../utils/constants";
import membershipABI from "../../contracts_abi/membership.json";

const SECRET = 'nblEqofdMPN5VcVp'

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      name: "",
      email: "",
      gender: "",
      file: "",
      fileName: "",
      imageDisplay: ""
    };
  }

  componentDidMount() {
    this.getProfile();
  }

  getProfile = async () => {
    try {
      this.setState({ showLoader: true });
      const account = localStorage.getItem('walletAddress');
      const web3 = new Web3(Web3.givenProvider);
      const myContract = await new web3.eth.Contract(membershipABI, contractAddress);
      const response = await myContract.methods
        .getAdminUser(account)
        .call();
      if (response) {
        const decrypt = await GeneralFunctions.decrypt(response, SECRET);
        const decryptData = JSON.parse(decrypt);
        this.setState({
          showLoader: false,
          name: decryptData.name,
          email: decryptData.email,
          gender: decryptData.gender
        });
      } else {
        this.setState({
          showLoader: false
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  updateProfile = async (event) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      const data = {
        name: this.state.name,
        email: this.state.email,
        gender: this.state.gender,
      };
      const hash = await GeneralFunctions.encrypt(JSON.stringify(data), SECRET);
      const account = localStorage.getItem('walletAddress');
      const web3 = new Web3(Web3.givenProvider);
      const myContract = await new web3.eth.Contract(membershipABI, contractAddress);
      const response = await myContract.methods
        .setAdminUser(hash)
        .send(
          {
            from: account
          }
        );
      if (response && response.status) {
        this.setState({ showLoader: false });
        this.notificationSystem.addNotification({
          message: 'Profile updated successfully',
          level: "success",
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    this.setState({
      file: fileUploaded,
      fileName: fileUploaded.name,
    });
    event.target.value = "";
  };

  uploadFile = async () => {
    try {
      if (!this.state.file) throw Error('Select the file');
      // this.setState({ showLoader: true });
      const client = create('http://localhost:5001');
      const { path } = await client.add(this.state.file);
      // const data = {
      //   name: this.state.name,
      //   email: this.state.email,
      //   gender: this.state.gender,
      // };
      // const hash = await GeneralFunctions.encrypt(JSON.stringify(data), SECRET);
      // const account = localStorage.getItem('walletAddress');
      // const web3 = new Web3(Web3.givenProvider);
      // const myContract = await new web3.eth.Contract(membershipABI, contractAddress);
      // const response = await myContract.methods
      //   .setUser(hash)
      //   .send(
      //     {
      //       from: account
      //     }
      //   );
      // if (response && response.status) {
      //   this.setState({ showLoader: false });
      //   this.notificationSystem.addNotification({
      //     message: 'Profile updated successfully',
      //     level: "success",
      //   });
      // }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  render() {
    return (
      <div>
        <PageSpinner showLoader={this.state.showLoader} />
        <Page
          title="Profile"
          breadcrumbs={[
            {
              name: "Profile",
              active: true,
            },
          ]}
        >
          <Row>
            <Col>
              <Card className="mb-3">
                <CardBody>
                  <Form
                    onSubmit={this.updateProfile}
                  >
                    {/* <Row>
                      <Col xl={6} lg={12} md={12}>
                        <Avatar
                          className="mr-3"
                          size='70px'
                          src={userImage}
                        />
                        <label htmlFor="file">
                          <span
                            style={{ cursor: "pointer" }}
                          >
                            {this.state.fileName
                              ? this.state.fileName
                              : "Add Avatar"
                            }
                            <FiEdit size="20px" className="ml-2" />
                          </span>
                        </label>
                        <input
                          style={{ display: "none" }}
                          id="file"
                          type="file"
                          accept=".png,.jpg,.jpeg"
                          onChange={this.handleChange}
                        />
                        <Button
                          color="primary"
                          onClick={this.uploadFile}
                          style={{ float: "right", marginTop: "15px" }}>
                          Save
                        </Button>
                      </Col>
                    </Row> */}
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="name">Name</Label>
                          <Input
                            type="text"
                            name="name"
                            required
                            value={this.state.name || ""}
                            placeholder="Name"
                            autoComplete="off"
                            onChange={(event) =>
                              this.setState({
                                name: event.target.value
                              })
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="email">Email</Label>
                          <Input
                            type="text"
                            name="email"
                            value={this.state.email || ""}
                            placeholder="Email"
                            autoComplete="off"
                            onChange={(event) =>
                              this.setState({
                                email: event.target.value
                              })
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <FormGroup>
                          <Label for="gender">Gender</Label>
                          <Input
                            type="text"
                            name="gender"
                            value={this.state.gender || ""}
                            placeholder="Gender"
                            autoComplete="off"
                            onChange={(event) =>
                              this.setState({
                                gender: event.target.value
                              })
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xl={6} lg={12} md={12}>
                        <Button color="primary" type="submit">
                          Update Profile
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
export default Profile;
